<template>
  <div class="d-flex justify-content-between align-items-center">
    <div>
      <span>{{maxCount}} {{ $t('ui.entries') }} | </span>
      <label class="me-1" for="max">{{$t('ui.entriesPerPage')}}</label>
      <input
          class="me-1"
          id="max"
          :value="maxInvoices"
          @blur="setMax($event.target.value)"
          @change="setMax($event.target.value)"
          type="number"
          min="1"
          max="100"
      >
      |
      <span class="ms-1 me-2">{{$t('ui.page')}} <span class="fw-bold">{{ currentPage }} / {{pageCount < 1 ? 1 : pageCount}}</span></span>
    </div>
    |
    <button class="btn ehw-green btn-sm border-0 ms-2 me-2" style="height: 30px" :disabled="currentPage === 1" @click="changePage(currentPage - 1)">
      {{$t('ui.previous')}}
    </button>
    <button class="btn ehw-green btn-sm border-0"  style="height: 30px"  :disabled="currentPage >= pageCount" @click="changePage(currentPage + 1)">{{$t('ui.next')}}</button>
  </div>
</template>

<script>
export default {
  name: "AppPagination",
  props: {
    currentPage: {
      type: Number,
      required: true
    },
    maxInvoices: {
      type: Number,
      required: true
    },
    maxCount: {
      type: Number,
      required: true
    },
    pageCount: {
      type: Number,
      required: true
    }
  },
  methods: {
    changePage(page) {
      this.$emit("page-change", page);
    },
    setMax(max) {
      this.$emit("set-max", max);
    }
  }
};
</script>